<script>
export default {
  data: () => ({
    modal: false,
    relatorios: []
  }),
  methods: {
    open (list) {
      this.relatorios = list
      this.modal = true
    },
    close () {
      this.relatorios = []
      this.modal = false
    },
    onClose () {
      this.modal = false
      this.$emit('onClose')
    },
    escolhe (item) {
      this.$emit('escolhe', item)
      this.modal = false
    }
  }
}
</script>

<template>
  <v-dialog v-model="modal" @input="v => v || onClose()" width="300">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Relatórios
      </v-card-title>
      <v-card-text class="modal-relatorios-conteudo">
        <dx-list :data-source="relatorios" height="100%">
          <div slot="item" slot-scope="item" :item="item" @click="escolhe(item)">
            {{ item.nome }}
          </div>
        </dx-list>
        <div class="button-footer">
          <v-btn @click="modal=false"> Cancelar </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
  .modal-relatorios-conteudo .dx-list {
    border: 1px solid #ddd;
    border-radius:4px;
    margin-bottom: 5px;
  }
  .modal-relatorios-conteudo .dx-list-item {
    padding: 5px 3px;
  }
  .modal-relatorios-conteudo {
    text-align: left;
  }
  .modal-relatorios-conteudo .button-footer {
    text-align: right;
  }
</style>
